import { render, staticRenderFns } from "./PetList.vue?vue&type=template&id=0273da83"
import script from "./PetList.vue?vue&type=script&lang=js"
export * from "./PetList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports